import "bootstrap/dist/css/bootstrap.min.css";
import "core-js/es/string/replace-all";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.map";
import "core-js/modules/es.set";
import "core-js/stable";
import "element-polyfill";
import "normalize.css";
import "raf/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./assets/sass/main.scss";
import App from "./containers/app";
import "./index.css";
//@ts-ignore
import replaceAllInserter from "string.prototype.replaceall";

replaceAllInserter.shim();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
